<template>
  <div :class="col" class="mt-3">

    <vb-card class="passengers" :card="{
      title: card_title,
      subtitle: card_subtitle,
    }">
      <div class="passengers__text">
        <ul>
          <li>Data di nascita: <strong class="semibold">{{ formatted_birthday }}</strong></li>
          <li v-if="passenger_info.nationality">Nazionalità: <strong class="semibold">{{ passenger_info.nationality }}</strong></li>
          <li v-if="passenger_info.prefix_phone && passenger_info.phone">Cellulare: <strong class="semibold">+{{ passenger_info.prefix_phone }} {{ passenger_info.phone }}</strong></li>
        </ul>
      </div>
    </vb-card>

  </div>

</template>

<script>
import Card from '@library/blocks/card'
import moment from 'moment'
import {
  get_pax_field,
  type_pax_options,
  gender_options,
} from '@resources/passenger'
import { passenger_to_flat } from '@alpitour/utilities/passenger'

const options_to_map = (options) => options.reduce((acc, { value, text }) => {
  if (value) { acc[value] = text }
  return acc
}, {})

const pax_type_labels = options_to_map(type_pax_options)
const gender_prefixes = options_to_map(gender_options)

export default {
  name: 'card-pax',

  props: {
    pax: Object,
    // 1 based index, 0 means unset
    index: {
      type: Number,
      default: 0,
    },
    col: {
      type: String,
      default: '',
    },
  },

  components: {
    'vb-card': Card,
  },

  computed: {
    passenger_info() {
      if (this.pax.details && this.pax.details.fields) {
        const raw = passenger_to_flat(this.pax)
        const info = {}
        Object.keys(raw).forEach(key => {
          info[get_pax_field(key)] = raw[key]
        })
        // passenger_to_flat skips type_pax (internal), but the card needs it
        const type_field = this.pax.details.fields.find(f => get_pax_field(f.name) === 'type_pax')
        if (type_field && type_field.value) {
          info.type_pax = type_field.value
        }
        return info
      }
      // Already flat — canonicalize keys
      const info = {}
      Object.keys(this.pax).forEach(key => {
        if (this.pax[key] !== undefined && this.pax[key] !== null) {
          info[get_pax_field(key)] = this.pax[key]
        }
      })
      return info
    },
    card_title() {
      const prefix = gender_prefixes[this.passenger_info.gender]
      return `${prefix ? `${prefix} ` : ''}${this.passenger_info.name || ''} ${this.passenger_info.surname || ''}`
    },
    card_subtitle() {
      const age_label = pax_type_labels[this.passenger_info.type_pax] || 'ADULTO'
      if (!this.pax.id && this.index <= 0) {
        return age_label
      }
      return `Viaggiatore ${this.pax.id || this.index} - ${age_label}`
    },
    formatted_birthday() {
      if (!this.passenger_info.birthday) { return '' }
      return moment(this.passenger_info.birthday).format('DD-MM-YYYY')
    },
  },
}
</script>

<style lang="scss" scoped>

  .passengers {
    min-height: 100%;
    border: 0;

    &__text {
      ul {
        padding-left: $grid-gutter-width/4;
        list-style: inside;
        list-style-type: circle;
        margin-top: $grid-gutter-width/6;
        margin-bottom: 0;
      }
    }
  }

  ::v-deep {

    .vb-card {

      &__head {
        display: flex;
        flex-direction: column;
      }

      &__subtitle {
        font-size: $font-size-sm;
        margin-top: $grid-gutter-width/6;
        font-weight: $vb-font-weight-semibold;
      }
    }
  }

</style>